function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 43.478,
  height: 43.458,
  rx: 13
}), /*#__PURE__*/React.createElement(Path, {
  d: "M27.602 12.028h11.439v1.759H27.602zm0 5.432h11.439v1.759H27.602zm0 5.432h11.439v1.759H27.602zm0 5.976h11.439v1.759H27.602z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement(Path, {
  d: "M19.188 16.576A4.575 4.575 0 0014.612 12a4.575 4.575 0 00-4.576 4.576 4.575 4.575 0 004.576 4.576 4.575 4.575 0 004.576-4.576z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.223 29.763a8.61 8.61 0 10-17.222 0"
})));

function SvgIconSceneSplittedInactive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _ref);
}

export default SvgIconSceneSplittedInactive;